// removed by extract-text-webpack-plugin
module.exports = {"container":"get-location__container___3ExQK","button":"get-location__button___3nM9I","button_container":"get-location__button_container___35kCt","icon":"get-location__icon___HukeI","location_label":"get-location__location_label___1ZLlC","loader":"get-location__loader___cVlh1","load8":"get-location__load8___3plRX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/get-location.pcss
// module id = 225
// module chunks = 0